import type { ChecklistBlock, LocaleCode } from '@fixit/bozp-content';
import { resolveLocalized } from '../locale';

export function ChecklistBlockView({
  block,
  locale,
}: {
  block: ChecklistBlock;
  locale: LocaleCode;
}) {
  return (
    <ul data-block-type="checklist">
      {block.items.map((item, idx) => (
        <li key={idx}>{resolveLocalized(item, locale)}</li>
      ))}
    </ul>
  );
}
